import { Accessor } from '@deck.gl/core';
import { RangeType } from '../../../RangeType';
import { HidableLineLayer } from '../line/hidable-line-layer';
import { vectorLineLayerUniforms, VectorLineLayerUniforms } from './vector-line-layer-uniforms';
import vertexShader from './vector-line-vertex-shader.glsl?raw';

export type VectorLineLayerProps<TData> = {
    getSpeed: Accessor<TData, number>;
    getHeading: Accessor<TData, number>;
    rangeType: RangeType;
    range: number;
};

export class VectorLineLayer<TData, TExtraProps = object> extends HidableLineLayer<TData, TExtraProps & VectorLineLayerProps<TData>> {
    initializeState() {
        super.initializeState();
        const manager = this.getAttributeManager()!;
        manager.remove(['instanceSourcePositions']);
        manager.remove(['instanceTargetPositions']);
        manager.addInstanced({
            instanceSourcePositions: {
                size: 3,
                type: 'float32',
                fp64: false,
                accessor: 'getSourcePosition'
            },
            instanceSpeed: {
                size: 1,
                defaultValue: 0.0,
                accessor: 'getSpeed'
            },
            instanceHeading: {
                size: 1,
                defaultValue: 0.0,
                accessor: 'getHeading'
            }
        });
    }

    getShaders() {
        const shaders = super.getShaders();
        return {
            ...shaders,
            modules: [...shaders.modules, vectorLineLayerUniforms],
            vs: vertexShader
        };
    }

    draw() {
        const { range, rangeType } = this.props;
        const { model } = this.state;
        const uniforms: VectorLineLayerUniforms = {
            rangeType,
            range
        };
        model?.shaderInputs.setProps({ feVectorLine: uniforms });
        super.draw({ uniforms });
    }
}
